@import '../../../../assets/style-helpers';
@import '../../../../assets/flexbox-helpers';
@import '../../../../assets/color-helpers';
@import '../../../../assets/common';

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    display: block;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: var(--main-titles-inputs-602);
  }
}

:host([isOpen]) {
  .overlay {
    opacity: 1;
    visibility: visible;
  }
}

.video {
  position: relative;
  display: flex;
  border-radius: 4px;

  width: 80%;
  height: 90%;
  padding-top: calc(5 * var(--spacer));

  .video-close {
    position: absolute;
    top: var(--spacer);
    right: 0;
    height: auto;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
}
